import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import type React from 'react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import VNSwitch from '@/components/VNSwitch/VNSwitch';

interface VNSectionProps {
  name: string;
  label: string;
  variant?: 'switch' | 'dropdown';
  isOpen?: boolean;
  toggleCallback?: () => void;
  children: React.ReactNode;
}

function VNSection({ name, label, variant = 'switch', isOpen, toggleCallback, children }: VNSectionProps) {
  const { watch } = useFormContext();
  const [open, setOpen] = useState(isOpen);
  const isExpanded = watch(name);

  if (variant === 'dropdown') {
    return (
      <div className="vn-section">
        <button
          type="button"
          className="section-header"
          onClick={() => {
            if (toggleCallback) {
              toggleCallback();
            }
            setOpen((prev) => !prev);
          }}
        >
          <div className="section-title">
            <span className="title-text">{label}</span>
            {open ? <KeyboardArrowUpOutlined className="icon" /> : <KeyboardArrowDownOutlined className="icon" />}
          </div>
        </button>
        <div className="container">{open && children}</div>
      </div>
    );
  }

  return (
    <div className="vn-section">
      {variant === 'switch' && <VNSwitch name={name} label={label} />}
      <div className="container">{isExpanded && children}</div>
    </div>
  );
}

export default VNSection;
